import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Building2 } from "lucide-react";

const CHIPS = ["Life", "Annuities", "Disability", "LTC", "Health", "Medicare", "Business", "Estate"];

export const CarrierBand = () => (
  <section
    id="carriers-band"
    data-testid="home-carrier-band"
    className="py-16 sm:py-20 bg-lw-navy text-lw-ivory"
  >
    <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12">
      <div className="flex items-start gap-3">
        <Building2 size={18} className="text-lw-gold mt-1" />
        <span className="text-[10px] uppercase tracking-[0.2em] font-semibold text-lw-gold">
          Independent — multi-carrier
        </span>
      </div>
      <h2 className="mt-4 font-serif-display text-3xl sm:text-4xl lg:text-5xl leading-[1.1] max-w-3xl">
        We work with A-rated carriers across every product category.
      </h2>
      <p className="mt-3 text-base text-lw-ivory/75 max-w-2xl">
        Independence means we&apos;re not captive to one company — we place your policy
        with the carrier that fits your state, health class, and product design.
      </p>

      <div className="mt-6 flex flex-wrap gap-2.5">
        {CHIPS.map((c) => (
          <span
            key={c}
            data-testid={`carrier-band-chip-${c.toLowerCase()}`}
            className="inline-flex items-center px-3.5 py-1.5 rounded-full border border-lw-ivory/25 text-xs text-lw-ivory/90"
          >
            {c}
          </span>
        ))}
      </div>

      <div className="mt-7 flex flex-wrap items-center gap-4">
        <Link
          to="/carriers"
          data-testid="home-carrier-band-cta"
          className="btn-gold"
        >
          See our full carrier network <ArrowRight size={16} />
        </Link>
        <p className="text-xs text-lw-ivory/60 max-w-md">
          Carrier appointments vary by state and situation. See our{" "}
          <Link to="/compliance" className="underline hover:text-lw-gold">
            compliance page
          </Link>{" "}
          for details.
        </p>
      </div>
    </div>
  </section>
);

export default CarrierBand;
